export default __webpack_public_path__ + "static/media/glass61.9ddee17b.jpg";